import { styled } from '@mui/material/styles';


export const ThemedBackground = styled('div')(
  ( { theme } ) => (
    {
      backgroundColor: theme.palette.background.neutral,
    }
  )
);
